import React, { useState } from 'react';
import Icon from './Icon';
import { Avatar, Pop } from './TaskList';

// Yeni hesap formu: açılacak Slack kanalları ve her kanala davet edilecek CRM kullanıcıları.
// Kanal adı = marka adı + ek (backend services/slackChannels.js ile aynı kural).

export function slugify(s) {
  return String(s || '').toLocaleLowerCase('tr')
    .replace(/ı/g, 'i').replace(/ş/g, 's').replace(/ç/g, 'c').replace(/ğ/g, 'g').replace(/ü/g, 'u').replace(/ö/g, 'o')
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
}
const suffixOf = (s) => { const x = slugify(s); return x ? `_${x}` : ''; };

// Şablondan varsayılan üyeler: tüm ekip (seçiliyse) + sabit üyeler + kanal ayarına göre atanan AM / PPC / Satışçı
// team: Slack ID'si olan aktif kullanıcıların id'leri
export function defaultMembers(tpl, assigned, team = []) {
  const ids = new Set(tpl.fixed_user_ids || []);
  if (tpl.include_all) team.forEach(id => ids.add(id));
  if (tpl.include_am && assigned.am_id) ids.add(Number(assigned.am_id));
  if (tpl.include_ppc && assigned.ppc_id) ids.add(Number(assigned.ppc_id));
  if (tpl.include_sales && assigned.sales_id) ids.add(Number(assigned.sales_id));
  return [...ids];
}

export function channelsFromTemplates(templates, assigned, team = []) {
  return templates.map(t => ({
    key: `t${t.id}`, suffix: t.suffix, label: t.label, is_client: t.is_client, tpl: t,
    member_user_ids: defaultMembers(t, assigned, team), touched: false,
  }));
}

function MemberAdder({ users, taken, onAdd }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState('');
  const n = (x) => String(x || '').toLocaleLowerCase('tr');
  const list = users.filter(u => !taken.includes(u.id) && (!q || n(u.name).includes(n(q))));
  return (
    <span style={{ position: 'relative' }}>
      <button type="button" className="sc-add" onClick={() => setOpen(true)}><Icon name="plus" size={12} /> Kişi ekle</button>
      <Pop open={open} onClose={() => { setOpen(false); setQ(''); }} width={260}>
        <input className="tl-pop__search" autoFocus placeholder="İsim ara…" value={q} onChange={(e) => setQ(e.target.value)} />
        <div className="tl-pop__scroll">
          {list.map(u => (
            <button key={u.id} type="button" className="tl-pop__item" onClick={() => onAdd(u.id)}>
              <Avatar user={u} size={18} /><span style={{ flex: 1 }}>{u.name}</span>
              {!u.slack_user_id && <span className="sc-warn">Slack ID yok</span>}
            </button>
          ))}
          {list.length === 0 && <div className="text-muted" style={{ padding: 8, fontSize: 12 }}>Eklenecek kişi kalmadı</div>}
        </div>
      </Pop>
    </span>
  );
}

export default function SlackChannelsPicker({ brand, users, channels, onChange }) {
  const [newSuffix, setNewSuffix] = useState('');
  const base = slugify(brand) || 'marka_adi';
  const byId = Object.fromEntries(users.map(u => [u.id, u]));
  const update = (key, patch) => onChange(channels.map(c => (c.key === key ? { ...c, ...patch, touched: true } : c)));
  const names = channels.map(c => `${base}${c.suffix}`);

  const addCustom = () => {
    const suffix = suffixOf(newSuffix);
    if (!suffix || names.includes(`${base}${suffix}`)) return;
    const main = channels.find(c => c.is_client) || channels[0];
    onChange([...channels, {
      key: `c${Date.now()}`, suffix, label: newSuffix.trim(), is_client: false, custom: true,
      member_user_ids: main ? [...main.member_user_ids] : [], touched: true,
    }]);
    setNewSuffix('');
  };

  return (
    <div className="sc">
      {channels.map(c => {
        const missing = c.member_user_ids.filter(id => byId[id] && !byId[id].slack_user_id);
        return (
          <div key={c.key} className="sc-card">
            <div className="sc-card__head">
              <span className="sc-name">#{base}{c.suffix}</span>
              <span className="text-muted" style={{ fontSize: 12 }}>{c.label}</span>
              {c.is_client && <span className="sc-badge">Müşteriyle ortak</span>}
              {c.custom && (
                <button type="button" className="sc-remove" title="Bu kanalı açma" onClick={() => onChange(channels.filter(x => x.key !== c.key))}>
                  <Icon name="x" size={12} />
                </button>
              )}
            </div>
            <div className="sc-members">
              {c.member_user_ids.map(id => byId[id] && (
                <span key={id} className={`sc-chip ${byId[id].slack_user_id ? '' : 'is-missing'}`} title={byId[id].slack_user_id ? 'Slack\'e davet edilecek' : 'Slack ID eksik: davet edilemez (Ayarlar → Kullanıcılar)'}>
                  <Avatar user={byId[id]} size={18} />{byId[id].name}
                  <button type="button" onClick={() => update(c.key, { member_user_ids: c.member_user_ids.filter(x => x !== id) })} aria-label="Çıkar">
                    <Icon name="x" size={10} />
                  </button>
                </span>
              ))}
              {c.member_user_ids.length === 0 && <span className="text-muted" style={{ fontSize: 12 }}>Kimse seçilmedi</span>}
              <MemberAdder users={users} taken={c.member_user_ids} onAdd={(id) => update(c.key, { member_user_ids: [...c.member_user_ids, id] })} />
            </div>
            {missing.length > 0 && (
              <div className="sc-note">Slack ID'si olmayanlar davet edilemez: {missing.map(id => byId[id].name).join(', ')}</div>
            )}
            {c.is_client && <div className="sc-note sc-note--info">Müşteri bu kanala Slack Connect ile ayrıca davet edilir.</div>}
          </div>
        );
      })}
      <div className="sc-new">
        <span className="sc-name text-muted">#{base}_</span>
        <input className="form-input" style={{ flex: 1, padding: '6px 10px' }} placeholder="Ek kanal (ör. reklam)" value={newSuffix}
          onChange={(e) => setNewSuffix(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); addCustom(); } }} />
        <button type="button" className="btn btn--secondary" style={{ padding: '6px 12px', fontSize: 13 }} onClick={addCustom} disabled={!slugify(newSuffix)}>+ Kanal ekle</button>
      </div>
    </div>
  );
}
